import React from 'react';

interface IconProps extends React.SVGProps<SVGSVGElement> {
  fillColor?: string; // Accepts color values or 'currentColor'
}

const MobileFolderIcon: React.FC<IconProps> = ({ fillColor, ...props }) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M13.3333 13.3333C13.6869 13.3333 14.0261 13.1929 14.2761 12.9428C14.5262 12.6928 14.6666 12.3536 14.6666 12V5.33333C14.6666 4.97971 14.5262 4.64057 14.2761 4.39052C14.0261 4.14048 13.6869 4 13.3333 4H8.06665C7.84366 4.00219 7.62368 3.94841 7.42685 3.84359C7.23002 3.73877 7.06262 3.58625 6.93998 3.4L6.39998 2.6C6.27857 2.41565 6.1133 2.26432 5.91898 2.1596C5.72466 2.05488 5.50739 2.00004 5.28665 2H2.66665C2.31302 2 1.97389 2.14048 1.72384 2.39052C1.47379 2.64057 1.33331 2.97971 1.33331 3.33333V12C1.33331 12.3536 1.47379 12.6928 1.72384 12.9428C1.97389 13.1929 2.31302 13.3333 2.66665 13.3333H13.3333Z"
        stroke={fillColor || '#9D9DA6'}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M1.33331 6.66669H14.6666" stroke={fillColor || '#9D9DA6'} strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export { MobileFolderIcon };
